import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface AdminPageShellProps {
  children: ReactNode;
  className?: string;
}

export function AdminPageShell({ children, className }: AdminPageShellProps) {
  return (
    <div
      className={cn(
        "mx-auto w-full max-w-7xl px-4 py-8 sm:px-6 lg:px-8 lg:py-10",
        className
      )}
    >
      {children}
    </div>
  );
}
